<p-drawer
  [(visible)]="visible"
  position="right"
  [modal]="true"
  [closable]="true"
  appendTo="body"
  styleClass="dr-dialog-wrapper"
  [style]="{ width: 'min(520px, 100vw)', height: 'min(100%, 100vh)' }"
  (onHide)="closeDialog()"
>
  <div class="dr-root" *ngIf="form" [formGroup]="form">
    <div class="dr-header">
      <div class="dr-header-icon dr-icon--warn">
        <i class="pi pi-key"></i>
      </div>
      <div class="dr-header-info">
        <div class="dr-title">Resetar Palavra-passe</div>
        <div class="dr-subtitle">
          {{ utilizador?.nome ?? "—" }} · {{ utilizador?.userName ?? "—" }}
        </div>
      </div>
    </div>

    <div class="dr-body">
      <div class="dr-form-group">
        <label class="dr-label">Utilizador (NIF)</label>
        <input
          class="dr-input"
          [value]="utilizador?.userName ?? '—'"
          readonly
          disabled
        />
      </div>

      <div class="dr-form-group">
        <label class="dr-label">E-mail</label>
        <input
          class="dr-input"
          [value]="utilizador?.email ?? '—'"
          readonly
          disabled
        />
      </div>

      <div class="dr-form-group">
        <div class="dr-label-row">
          <label class="dr-label">Nova Palavra-passe *</label>
          <button type="button" class="dr-btn-gerar" (click)="gerarPassword()">
            <i class="pi pi-sync"></i> Gerar palavra-passe
          </button>
        </div>
        <div class="dr-input-row">
          <input
            class="dr-input"
            formControlName="novaPassword"
            [type]="showPassword ? 'text' : 'password'"
            placeholder="Mínimo 8 caracteres"
          />
          <button
            type="button"
            class="dr-icon-btn"
            (click)="showPassword = !showPassword"
            [attr.aria-label]="
              showPassword ? 'Ocultar palavra-passe' : 'Mostrar palavra-passe'
            "
          >
            <i
              class="pi"
              [ngClass]="showPassword ? 'pi-eye-slash' : 'pi-eye'"
            ></i>
          </button>
          <button
            type="button"
            class="dr-icon-btn"
            *ngIf="geradaAgora"
            (click)="copiarPassword()"
            aria-label="Copiar palavra-passe"
          >
            <i class="pi pi-copy"></i>
          </button>
        </div>
        <span
          class="ad-error-msg"
          *ngIf="submitted && f['novaPassword'].errors?.['required']"
        >
          Nova palavra-passe é obrigatória.
        </span>
        <span
          class="ad-error-msg"
          *ngIf="submitted && f['novaPassword'].errors?.['minlength']"
        >
          Deve ter pelo menos 8 caracteres.
        </span>
      </div>

      <div class="dr-form-group">
        <label class="dr-label">Confirmar Nova Palavra-passe *</label>
        <div class="dr-input-row">
          <input
            class="dr-input"
            formControlName="confirmarNovaPassword"
            [type]="showPassword ? 'text' : 'password'"
            placeholder="Repita a nova palavra-passe"
          />
        </div>
        <span
          class="ad-error-msg"
          *ngIf="submitted && f['confirmarNovaPassword'].errors?.['required']"
        >
          Confirmação é obrigatória.
        </span>
        <span
          class="ad-error-msg"
          *ngIf="
            submitted && f['confirmarNovaPassword'].errors?.['passwordMismatch']
          "
        >
          As palavras-passe não coincidem.
        </span>
      </div>

      <div class="dr-warn-note">
        <i class="pi pi-info-circle"></i>
        <span
          >Comunique a nova palavra-passe ao utilizador por um canal
          seguro.</span
        >
      </div>
    </div>

    <div class="dr-footer">
      <button type="button" class="ad-btn-cancel" (click)="closeDialog()">
        Cancelar
      </button>
      <button
        type="button"
        class="dr-btn-reset"
        [disabled]="loading"
        (click)="onSubmit()"
      >
        <i class="pi pi-spin pi-spinner" *ngIf="loading"></i>
        <i class="pi pi-key" *ngIf="!loading"></i>
        {{ loading ? "A resetar..." : "Resetar" }}
      </button>
    </div>
  </div>
</p-drawer>
